import * as React from 'react';
import { Link } from '../../../../../common/Link';
import { ErrorWrapper } from '../ErrorWrapper';
import { pointerIcon } from '../../icons';

interface IPriceAndGeoEmptyProps {
  onLinkClickGeo(): void;
  onLinkClickPrice(): void;
}

export const PriceAndGeoEmpty = ({ onLinkClickGeo, onLinkClickPrice }: IPriceAndGeoEmptyProps) => {
  return (
    <ErrorWrapper icon={pointerIcon}>
      Введите <Link onClick={onLinkClickGeo}>адрес</Link>&nbsp;и&nbsp;
      <Link onClick={onLinkClickPrice}>цену</Link>, чтобы увидеть, на какой странице поиска будет объявление
    </ErrorWrapper>
  );
};
